import { AutomaticRecharge } from "./automatic-recharge";
import { OrderData } from "./order-data";

export class Wallet {
  code: string;
  productValue: string;
  balance: string;
  automaticRecharge: AutomaticRecharge;
  orderData: OrderData;

  constructor(walletData?: any) {
    if (walletData) {
      this.code = walletData.code;
      this.productValue = walletData.productValue;
      this.balance = walletData.balance;
      if (walletData.automaticRecharge) {
        this.automaticRecharge = new AutomaticRecharge(walletData.automaticRecharge);
      }
      if (walletData.orderData) {
        this.orderData = new OrderData(walletData.orderData);
      }
    }
  }
}
